import React, {useState, useEffect} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import useMediaQuery from '@mui/material/useMediaQuery'

import {useTheme} from '@mui/material/styles'

import {updateRadiusFilter, initiateSearch, clearFilter} from '../../actions'

import Slider from '@mui/material/Slider'


import FilterHeader from './FilterHeader'
import FilterFooter from './FilterFooter'



const cssStyles = ({padding, isSmallScreen}) => ({
  root: css`
    width: 100%;
    min-width: ${isSmallScreen ? '100%' : '350px'};
    max-width: 600px;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${padding ? padding : '60px 40px 40px 40px'};
  `,
  captionContainer: css`
    height: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 10px;

    p {
      text-align: center;
    }
  `,
  footerContainer: css`
    width: 100%;
    bottom: 0;
    background-color: #fff;
    z-index: 50
  `
})



const marks = [
  { 
    value: 3,
    label: 'Walk'
  },
  {
    value: 20,
    label: 'Drive'
  },
  {
    value: 100,
    label: 'Trip'
  }
]



function valuetext(value) {
  return `${value}`
}



const RadiusFilter = props => {

  const theme = useTheme()

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))


  const {
    initiateSearch, 
    updateRadiusFilter, 
    stateRadius, 
    clearFilter,
    hideHeader,
    hideFooter,
    padding,
    callback,
    close
  } = props


  const styles = cssStyles({padding, isSmallScreen})


  const [radius, setRadius] = useState(stateRadius)



  const handleRadiusChange = (_, value) => {
    value = parseFloat(value).toFixed(1)
    value = value > 500 ? 500 : Math.abs(value)

    setRadius(value)
  }


  useEffect(() => {
    if (callback) {
      callback(radius)
    } 
  }, [radius, callback])



  function apply() {
    if (radius !== stateRadius) {
      updateRadiusFilter(radius)
      initiateSearch()
      close()
    }
  }



  function clear() {
    setRadius(null)

    if (stateRadius !== null || stateRadius !== 50) {
      clearFilter('RADIUS')
      initiateSearch()
      close()
    }
  }


  return (
    <div css={styles.root}>
      {!hideHeader && <FilterHeader title='Select Search Distance' clear={clear} close={close} />}

      <div css={styles.body}>
        <Slider
          sx={{
            '& .MuiSlider-thumb': {
              color: theme.palette.pink.main
            }
          }}
          min={0.5}
          marks={marks}
          value={radius}
          onChange={handleRadiusChange}
          valueLabelDisplay='auto'
          aria-labelledby='range-slider'
          getAriaValueText={valuetext} 
        />


        <div css={styles.captionContainer}>
          {radius && <p>Search radius: <strong>{parseInt(radius)} miles</strong></p>}
        </div>
      </div>

      <div css={styles.footerContainer}>
        {!hideFooter && <FilterFooter onClick={apply} />}
      </div>
    </div>
  )
}


const mapStateToProps = state => {
  return {
    stateRadius: state.search.filters.location.radius
  }
}


const actions = {updateRadiusFilter, initiateSearch, clearFilter}


export default connect(mapStateToProps, actions)(RadiusFilter)



